import {baseConfig} from '../helpers/baseConfig'

export const cashappConfig = (props) => {
    return {
        ...baseConfig(props),
        showPayButton: true,
        storePaymentMethod: true
    }
}
